import type { ActionIdRegistry } from '@festina-life/core'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useCallback, useState } from 'react'

import { scenarioStyles } from '../participantOverview/scenarios/scenarioStyles'
import { LifeCommitmentSaveOrCreateScenarioModalManager } from './LifeCommitmentSaveOrCreateScenarioModalManager'

type Props = {
  actionId: keyof ActionIdRegistry
  onSubmitScenarioSuccess?: () => Promise<unknown>
}

export const LifeCommitmentSaveOrCreateScenarioModalButton = ({
  actionId,
  onSubmitScenarioSuccess,
}: Props) => {
  const translate = useTranslate()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOnClose = useCallback(() => {
    // useCallback is important, as ModalManager has an effect dependency on this.
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <div className="contents" style={scenarioStyles}>
        <Button onClick={() => setIsModalOpen(true)}>
          {translate('commitmentScenario.modal.create')}
        </Button>
      </div>
      <LifeCommitmentSaveOrCreateScenarioModalManager
        actionId={actionId}
        isModalOpen={isModalOpen}
        onCloseModal={handleOnClose}
        onSubmitScenarioSuccess={onSubmitScenarioSuccess}
      />
    </>
  )
}
